import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function SubPageHeader({ title, right }) {
  const nav = useNavigate();
  return (
    <div
      className="sticky top-0 z-30 pt-safe"
      style={{ background: "#0A0D14", borderBottom: "1px solid #1E2640" }}
    >
      <div className="flex items-center justify-between px-4 h-14">
        <button
          onClick={() => nav(-1)}
          data-testid="back-button"
          className="w-9 h-9 rounded-lg flex items-center justify-center"
          style={{ background: "#161B2C", border: "1px solid #1E2640", color: "#E8ECFF" }}
          aria-label="Back"
        >
          <ChevronLeft size={18} />
        </button>
        <div className="text-[15px] font-syne font-bold tracking-tight" style={{ color: "#E8ECFF" }}>
          {title}
        </div>
        <div className="min-w-[36px] flex items-center justify-end">{right}</div>
      </div>
    </div>
  );
}
